import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { ItemComponentStore, ItemId } from 'products-data';
import { ProductComponentBase } from '../../../../product/ProductComponentBase';
import { ItemResultListComponent } from '../item-result-list/item-result-list.component';

@Component({
  selector: 'ideal-item-results',
  imports: [ItemResultListComponent],
  standalone: true,
  templateUrl: './item-results.component.html',
  styleUrl: './item-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ItemComponentStore],
})
export class ItemResultsComponent extends ProductComponentBase {
  private readonly _productItemsComponentStore = inject(ItemComponentStore);

  public readonly idFilter = input<((id: ItemId) => boolean) | null>(null);

  protected readonly ids = computed(() => this._productItemsComponentStore.productItems().map((item) => item?.id ?? null));

  protected readonly filteredIds = computed(() => {
    const filter = this.idFilter();
    if (!filter) return this.ids();
    return this.ids().filter(filter);
  });

  constructor() {
    super();
    effect(() => {
      this._productItemsComponentStore.selectProductById(this.productId());
    });
  }
}
